import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";

var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('main', {
    staticClass: "main page_absence_classroom"
  }, [_c('h1', {
    staticClass: "title--page"
  }, [_vm._v(_vm._s(_vm.formattedDate) + "の出欠席一覧 - クラス名簿別")]), _c('form', {
    staticClass: "gray_frame",
    attrs: {
      "action": "",
      "method": "get"
    }
  }, [_vm._l(_vm.grades, function (grade, i) {
    return _c('row-item', {
      key: i,
      staticClass: "wrap"
    }, _vm._l(grade.classroom, function (classroom, i2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: classroom.pivot.grade_id === grade.id,
          expression: "classroom.pivot.grade_id === grade.id"
        }],
        key: i2
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.checkedClassrooms,
          expression: "checkedClassrooms"
        }],
        staticClass: "common_form--checkbox",
        attrs: {
          "id": ['classroom_'] + classroom.id,
          "type": "checkbox"
        },
        domProps: {
          "value": classroom.id,
          "checked": Array.isArray(_vm.checkedClassrooms) ? _vm._i(_vm.checkedClassrooms, classroom.id) > -1 : _vm.checkedClassrooms
        },
        on: {
          "change": function change($event) {
            var $$a = _vm.checkedClassrooms,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;

            if (Array.isArray($$a)) {
              var $$v = classroom.id,
                  $$i = _vm._i($$a, $$v);

              if ($$el.checked) {
                $$i < 0 && (_vm.checkedClassrooms = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.checkedClassrooms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.checkedClassrooms = $$c;
            }
          }
        }
      }), _c('label', {
        staticClass: "common_form--label",
        attrs: {
          "for": ['classroom_'] + classroom.id
        }
      }, [_vm._v(_vm._s(classroom.name))])]);
    }), 0);
  }), _c('row-item', {
    staticClass: "change_area"
  }, [_c('div', {
    staticClass: "col_3"
  }, [_c('VueCtkDateTimePicker', {
    attrs: {
      "label": "日付",
      "no-button-now": "",
      "only-date": "",
      "formatted": "LL",
      "locale": "ja",
      "output-format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1), _c('div', {
    staticClass: "col_9 tar"
  }, [_c('input', {
    staticClass: "change_button",
    attrs: {
      "type": "submit",
      "value": "変更",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.setData.apply(null, arguments);
      }
    }
  })])])], 2), _vm.isLoading ? _c('content-placeholders', _vm._l(5, function (n) {
    return _c('div', {
      key: n
    }, [_c('div', {
      staticClass: "fake_scroll_table__body"
    }, [_c('div', {
      staticClass: "student_list"
    }, [_c('p', [_c('content-placeholders-text', {
      attrs: {
        "lines": 1
      }
    })], 1)])])]);
  }), 0) : _c('row-item', {
    staticClass: "wrap start"
  }, _vm._l(_vm.byClassrooms, function (classroom, index) {
    return _c('div', {
      key: index,
      staticClass: "student_list"
    }, [_c('row-item', {
      staticClass: "student_list__heading wrap between"
    }, [_c('p', {
      staticClass: "heading"
    }, [_vm._v(" " + _vm._s(classroom.name) + " ")]), _c('row-item', {
      staticClass: "wrap"
    }, [_c('button', {
      staticClass: "download_button",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.downloadStudentsCSV(classroom, _vm.grades, _vm.studentAddress);
        }
      }
    }, [_vm._v(" 名簿ダウンロード ")]), _c('router-link', {
      staticClass: "show_button",
      attrs: {
        "to": {
          name: 'attendances.monthly',
          query: {
            classroom_id: classroom.id
          }
        }
      }
    }, [_vm._v(" 月ごとに見る ")])], 1)], 1), _c('ul', _vm._l(classroom.students, function (student, i) {
      return _c('li', {
        key: i
      }, [_c('row-item', [_c('div', {
        staticClass: "col_7"
      }, [_c('span', {
        staticClass: "student_list__name"
      }, [_vm._v(" " + _vm._s(student.name) + " ")]), _vm._l(student.absents, function (count, i2) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: student.absents.length > 0,
            expression: "student.absents.length > 0"
          }],
          key: i2
        }, [_c('p', {
          staticClass: "icon--date"
        }, [_c('span', {
          staticClass: "num"
        }, [_vm._v(_vm._s(count))]), _vm._v(" 欠 ")])]);
      }), student.attendance[0] && student.attendance[0].is_daily_latest ? _c('div', [_c('p', {
        class: "icon--".concat(_vm.iconColor(student.attendanceType))
      }, [_vm._v(" " + _vm._s(student.attendanceType) + " ")])]) : _vm._e()], 2), _c('div', {
        staticClass: "col_5 tar"
      }, [_c('router-link', {
        staticClass: "detail_button",
        attrs: {
          "to": {
            name: 'attendances.detail',
            query: {
              student_id: student.id
            }
          }
        }
      }, [_vm._v(" 詳細 ")]), student.attendanceType ? _c('router-link', {
        staticClass: "update_button",
        attrs: {
          "to": {
            name: 'attendances.edit',
            params: {
              id: student.attendance[0].id
            }
          }
        }
      }, [_vm._v(" 更新 ")]) : _c('router-link', {
        staticClass: "update_button",
        attrs: {
          "to": {
            name: 'attendances.create',
            query: {
              student_id: student.id
            }
          }
        }
      }, [_vm._v(" 登録 ")])], 1)])], 1);
    }), 0)], 1);
  }), 0), _c('section', {
    staticClass: "tac"
  }, [_c('router-link', {
    staticClass: "return_button",
    attrs: {
      "to": {
        name: 'attendances',
        query: {
          date: _vm.date
        }
      }
    }
  }, [_vm._v(" 出欠席一覧に戻る ")])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };